module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p4-562b2f9f2cf89a809ea7ce0dfd1a541b.png";